// Info: Import Local Dependancies
import { env } from './env';

const {
  siteCoreBaseUrl,
  siteCoreBasePath,
  siteCoreToken,
} = env

export const endpoints = {
  "siteCore": {
    appUrl: `${siteCoreBaseUrl}${siteCoreBasePath}/app`,
    token: siteCoreToken
  },
}